import { get, set, del } from './storage';

export const TOKEN_KEY = 'bkl_tkn';
export const EXP_KEY = 'bkl_exp';

export const setToken = (t, e) => {
  // Access token is now in HttpOnly cookie — only store expiry for AutoLogout
  set(EXP_KEY, e);
};

export const getToken = () => {
  // Access token is in HttpOnly cookie, not accessible via JS
  const exp = get(EXP_KEY) || null;
  return { token: null, exp };
};

export default (() => ({
  isAuthenticated: () => {
    const { exp } = getToken();
    return exp && Math.floor(+Date.now() / 1000) < parseInt(exp, 10);
  },
  logout: () => {
    del(EXP_KEY);
    return Promise.resolve();
  },
}))();

// The interval in milliseconds that we check the expiry value of the token
// NOTE: This is a sync call and will block the UI so we should not do this too often
export const TOKEN_EXPIRY_CHECK_INTERVAL = 10000;

// The number of seconds before the token expires that the warning modal is displayed to a user, to allow them to refresh their token
export const SECONDS_TILL_LOGOUT_WARNING = 90;
